/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateBondRunStatusOptions,
  UpdateBondRunStatusStatus200,
  UpdateBondRunStatusStatus400,
  UpdateBondRunStatusStatus401,
  UpdateBondRunStatusStatus403,
  UpdateBondRunStatusStatus404,
  UpdateBondRunStatusStatus500,
} from '../types/UpdateBondRunStatus'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateBondRunStatus } from '../clients/updateBondRunStatus'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateBondRunStatusMutationKey = () =>
  [{ url: '/v1/assets/:asset_id/bond_run_status' }] as const

export function updateBondRunStatusMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateBondRunStatusMutationKey()
  return mutationOptions<
    UpdateBondRunStatusStatus200,
    ResponseErrorConfig<
      | UpdateBondRunStatusStatus400
      | UpdateBondRunStatusStatus401
      | UpdateBondRunStatusStatus403
      | UpdateBondRunStatusStatus404
      | UpdateBondRunStatusStatus500
    >,
    UpdateBondRunStatusOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateBondRunStatus({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @summary Update treasury bond run status
 * {@link /v1/assets/:asset_id/bond_run_status}
 */
export function useUpdateBondRunStatus<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateBondRunStatusStatus200,
      ResponseErrorConfig<
        | UpdateBondRunStatusStatus400
        | UpdateBondRunStatusStatus401
        | UpdateBondRunStatusStatus403
        | UpdateBondRunStatusStatus404
        | UpdateBondRunStatusStatus500
      >,
      UpdateBondRunStatusOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateBondRunStatusMutationKey()

  const baseOptions = updateBondRunStatusMutationOptions(config) as UseMutationOptions<
    UpdateBondRunStatusStatus200,
    ResponseErrorConfig<
      | UpdateBondRunStatusStatus400
      | UpdateBondRunStatusStatus401
      | UpdateBondRunStatusStatus403
      | UpdateBondRunStatusStatus404
      | UpdateBondRunStatusStatus500
    >,
    UpdateBondRunStatusOptions,
    TContext
  >

  return useMutation<
    UpdateBondRunStatusStatus200,
    ResponseErrorConfig<
      | UpdateBondRunStatusStatus400
      | UpdateBondRunStatusStatus401
      | UpdateBondRunStatusStatus403
      | UpdateBondRunStatusStatus404
      | UpdateBondRunStatusStatus500
    >,
    UpdateBondRunStatusOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateBondRunStatusStatus200,
    ResponseErrorConfig<
      | UpdateBondRunStatusStatus400
      | UpdateBondRunStatusStatus401
      | UpdateBondRunStatusStatus403
      | UpdateBondRunStatusStatus404
      | UpdateBondRunStatusStatus500
    >,
    UpdateBondRunStatusOptions,
    TContext
  >
}
